import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import properties from '../../constants/Properties';
import storeManager from '../../store/StoreManager';
import { changeStorySoundVolume } from '../../actions/ProductionActions';
import { changeSlideSoundVolume } from '../../actions/CurrentSlideActions';
import { changeTimelineVolume, changeVolume } from '../../actions/AudioEditorActions';
import saveManager from '../utils/SaveManager';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import locales from "../../locales/LocalesManager";

export const VolumeSliderContent = React.createClass({
    getInitialState () {
        const steps = 10;
        const props = this.getProperties();
        const realStep = (props.trackHeight - props.thumbSize) / steps;

        return {
            step: realStep,
            props,
            isThumbOver: false,
            isThumbActive: false
        };
    },
    componentDidMount() {
        this.drawTrack();

        if (platformDetection.isTouchableDevice()) {
            this.refs.track.addEventListener('touchend', this.onTrackMouseDown);

            if (platformDetection.isChromeBook())
                this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
        } else
            this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
    },
    componentWillReceiveProps(nextProps) {
        if (nextProps.positionLeft != this.props.positionLeft) {
            setTimeout(function() {
                const props = this.getProperties();

                this.setState({
                    props
                });
            }.bind(this), 100);
        }

        if (nextProps.visible != this.props.visible && nextProps.visible) {
            if (platformDetection.isIOS())
                return;

            setTimeout(function() {
                var thumbElement = this.refs.thumb;

                if (thumbElement)
                    thumbElement.focus();
            }.bind(this), 100);
        }
    },
    drawTrack () {
        var canvas = this.refs.track;
        const lineSize = 2;
        canvas.width = this.state.props.trackWidth;
        canvas.height = this.state.props.trackHeight;
        var ctx = canvas.getContext('2d');

        ctx.fillStyle = properties.DURATION_SLIDER_COLOR;
        ctx.fillRect(canvas.width / 2 - lineSize / 2, 0, lineSize, canvas.height);
        ctx.fill();
    },
    getCurrentStep (position) {
        const floatValue = position / this.state.step;
        const integerPart = parseInt(floatValue, 10);

        var newPosition;

        if ((floatValue - integerPart) > 0.5)
            newPosition = integerPart  + 1;
        else
            newPosition = integerPart;

        return newPosition;
    },
    getSliderPosition (position) {
        const newStep = this.getCurrentStep(position);
        return this.state.props.start + newStep * this.state.step;
    },
    getSliderValue (position) {
        const newStep = this.getCurrentStep(position);
        return this.state.props.end - newStep * this.state.props.step;
    },
    onTrackMouseDown (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var newPosition = mouseUtils.getLocalPosition(e, this.refs.track) - this.state.props.thumbSize / 2;

        if (newPosition < 0)
            newPosition = 0;

        if (newPosition > (this.state.props.trackHeight - this.state.props.thumbSize))
            newPosition = this.state.props.trackHeight - this.state.props.thumbSize;

        const sliderPosition = this.getSliderPosition(newPosition);

        this.refs.thumb.style.top = sliderPosition + 'px';

        this.changeProperties(this.getSliderValue(newPosition));
    },
    onMouseDown () {
        var topString = this.refs.thumb.style.top;
        var top = Number(topString.substring(0, topString.length - 2));

        this.setState({
            startPosition: top,
            currentPosition: top,
            isThumbActive: true
        });
    },
    onThumbMouseIn () {
        this.setState({
            isThumbOver: true
        });
    },
    onThumbMouseOut () {
        this.setState({
            isThumbOver: false
        });
    },
    checkPosition(deltaY) {
        var newPosition = (this.state.startPosition +  deltaY);
        const topValue = 0;
        const bottomValue = this.state.props.trackHeight - this.state.props.thumbSize;

        if (newPosition < topValue)
            newPosition = topValue;
        else if (newPosition > bottomValue)
            newPosition = bottomValue;

        const sliderPosition = this.getSliderPosition(newPosition);

        if(sliderPosition != this.state.currentPosition) {

            this.setState({
                currentPosition: sliderPosition
            });

            const value = this.getSliderValue(this.state.currentPosition);

            this.modifySoundVolume(value);
            saveManager.isContentChanged(true);
        }
    },
    modifySoundVolume(value) {
        value = value.toFixed(1);
        value = parseFloat(value);

        saveManager.isContentChanged(true);

        if (this.props.type == 'slideSound') {
            this.props.dispatch(changeSlideSoundVolume(value));
            audioEditorUtils.addActionToHistory();
            return;
        }

        if (this.props.type == 'slideSoundEffect') {
            this.props.dispatch(changeSlideSoundVolume(value, true));
            audioEditorUtils.addActionToHistory();
            return;
        }

        if (this.props.type == 'audioEditor') {
            this.props.dispatch(changeTimelineVolume(this.props.index, value));
            audioEditorUtils.addActionToHistory();
            return;
        }

        if (this.props.type == 'audioToolPlayer') {
            this.props.dispatch(changeVolume(value));
            return;
        }

        this.props.dispatch(changeStorySoundVolume(value));
        audioEditorUtils.addActionToHistory();
    },
    onMouseMove (e, coreEvent, movement) {
        if (movement)
            this.checkPosition(movement);
        else
            this.checkPosition(coreEvent.lastY);
    },
    onMouseUp (e, coreEvent) {
        this.checkPosition(coreEvent.lastY);

        this.setState({
            isThumbActive: false
        });
    },
    changeProperties (newValue) {
        if (newValue == undefined)
            return;

        saveManager.isContentChanged(true);

        this.modifySoundVolume(newValue);
    },
    getThumbPosition() {
        var value = this.getSoundVolume();

        if (value == undefined)
            value = 0.5;

        return (1 - value) * 10 * this.state.step;
    },
    getSoundVolume() {
        if (this.props.type == 'slideSound')
            return this.props.soundVolume;

        if (this.props.type == 'slideSoundEffect')
            return this.props.soundEffectVolume;

        if (this.props.type == 'audioEditor') {
            if (this.props.timelines[this.props.index] && this.props.timelines[this.props.index].isMute)
                return 0;
            else {
                if (this.props.timelines[this.props.index])
                    return this.props.timelines[this.props.index].volume;
                else
                    return 0;
            }
        }

        if (this.props.type == 'audioToolPlayer')
            return this.props.volume;

        return this.props.storySoundVolume;
    },
    getProperties() {
        var props = {};
        const hGap = 5;
        const vGap = 10;
        const volumeBottomPosition = 23;

        if (platformDetection.isIOS())
            props.thumbSize = 30;
        else
            props.thumbSize = 22;

        props.normalThumbSize = 22;
        props.width = 2 * hGap + props.normalThumbSize;
        props.height = properties.RECORDING_MENU_HEIGHT + properties.CANVAS_VERTICAL_BOTTOM_PADDING + properties.SLIDE_VIEWER_TOP_GAP + properties.SLIDE_VIEWER_LIST_HEIGHT;
        props.top = - props.height + properties.ADD_MUSIC_BUTTON_HEIGHT;
        props.left = 28;
        props.vGap = vGap;
        props.hGap = hGap;
        props.trackHeight = props.height - 2 * vGap - volumeBottomPosition + 5;
        props.trackWidth = props.width - 2 * hGap;
        props.step = 0.1;
        props.start = 0;
        props.end = 1;
        props.volumeTopPosition = props.height - volumeBottomPosition;

        if (this.props.type == 'slideSound' || this.props.type == 'slideSoundEffect') {
            props.left = props.left - 28;
            props.top = props.top + 2;
        } else if (this.props.type == 'audioEditor') {
            props.left = props.left + 124;
            props.top = props.top + 12;

            if (audioToolUtils.isAudioTool())
                props.top = props.top + (properties.AUDIO_TIMELINE_BIG_HEIGHT - properties.AUDIO_TIMELINE_HEIGHT) / 2;
        } else if (this.props.type == 'audioToolPlayer' || this.props.type == 'cartoonistUnexportedVolume') {
            props.left = this.props.positionLeft;
            props.top = -91;
        }

        return props;
    },
    onKeyDown(e) {
        var delta = this.state.step;

        if (e.keyCode == 38) { // Up Key
            this.onMouseDown();
            setTimeout(function() {
                this.onMouseMove(undefined, undefined, - delta);
            }.bind(this), 10);
        } else
        if (e.keyCode == 40) { // Down Key
            this.onMouseDown();
            setTimeout(function() {
                this.onMouseMove(undefined, undefined, delta);
            }.bind(this), 10);
        }

        if (e.keyCode == 9 || e.keyCode == 27) { // TAB or ESC
            if (this.props.closeVolumeSliderHandler)
                this.props.closeVolumeSliderHandler();
        }
    },
    render() {
        const localProps = this.state.props;
        var leftPos = localProps.left;

        if (this.props.isCollapsed) {
            leftPos = leftPos - (properties.BUTTONS_HOLDER_WIDTH - properties.BUTTONS_HOLDER_COLLAPSED_WIDTH);

            if (this.props.type == 'audioEditor')
                leftPos = leftPos + 25;
        }

        var displayVisibility = 'none';

        if (this.props.visible == true)
            displayVisibility = 'block';

        var wrapperStyle = {
            display: 'block',
            position: 'absolute',
            left: leftPos,
            top: localProps.top,
            width: localProps.width,
            height: localProps.height,
            display: displayVisibility,
            cursor: 'default'
        };

        const backgroundStyle = {
            position: 'absolute',
            width: localProps.width - 2,
            height: localProps.height - 2,
            top: 0,
            left: 0,
            background: 'white',
            borderStyle: 'solid',
            borderColor: 'black',
            borderWidth: 1,
            borderRadius: 50,
            cursor: 'default'
        };

        const holderStyle = {
            position: 'absolute',
            top: localProps.vGap,
            left: localProps.hGap,
            width: localProps.trackWidth,
            height: localProps.trackHeight
        };

        const trackStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: localProps.trackWidth,
            height: localProps.trackHeight,
            cursor: 'default'
        };

        const thumbBorderSize = 2;
        var thumbBorderColor = 'black';

        if (this.state.isThumbOver == true || this.state.isThumbActive == true)
            thumbBorderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        const thumbStyle = {
            position: 'absolute',
            width: localProps.thumbSize - 2 * thumbBorderSize,
            height: localProps.thumbSize - 2 * thumbBorderSize,
            left: (localProps.normalThumbSize - localProps.thumbSize) / 2,
            top: this.getThumbPosition(),
            background: 'white',
            borderStyle: 'solid',
            borderColor: thumbBorderColor,
            borderWidth: 2,
            borderRadius: 50,
            cursor: 'default',
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial'
        };

        const volumeIconStyle = {
            position: 'absolute',
            left: 11,
            top: localProps.volumeTopPosition,
            color: 'black'
        };

        var volumeIcon = 'fa fa-volume-down';
        var soundVolume = this.getSoundVolume();

        if (soundVolume == 0)
            volumeIcon = 'fa fa-volume-off';
        else if (soundVolume <= 0.5)
            volumeIcon = 'fa fa-volume-down';
        else if (soundVolume > 0.5)
            volumeIcon = 'fa fa-volume-up';

        var volumeIconId = 'volumeIcon';
        var id = 'volumeSlider';

        if (this.props.type == 'slideSound') {
            volumeIconId = 'volumeIcon1';
            id = 'volumeSlider1';
        } else if (this.props.type == 'slideSoundEffect') {
            volumeIconId = 'volumeIcon2';
            id = 'volumeSlider2';
        }

        if (audioToolUtils.isAudioTool() && this.props.type == 'audioEditor' && this.props.index == 0) {
            wrapperStyle.position = 'fixed';
            wrapperStyle.top = 75;
        }

        return (
            <div id={'volumeSlider_' + Math.random()} style={wrapperStyle}>
                <div style={backgroundStyle}/>
                <i id={'volumeIcon_' + Math.random()} style={volumeIconStyle} className={volumeIcon}></i>
                <div style={holderStyle}>
                    <canvas ref='track' style={trackStyle}/>
                    <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                        <button aria-label={locales.getCaption('volumeSliderThumb', 'other')} className='sliderThumb' ref='thumb' style={thumbStyle} onKeyDown={this.onKeyDown} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut}/>
                    </Draggable>
                </div>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const storySoundVolume = state.production.storySoundVolume;
    const soundVolume = (state.currentSlide && state.currentSlide.model) ? state.currentSlide.model.soundVolume : 1;
    const soundEffectVolume = (state.currentSlide && state.currentSlide.model) ? state.currentSlide.model.soundEffectVolume : 1;
    const timelines = state.audioEditor.timelines;
    var volume = state.audioEditor.volume;

    if (volume == undefined)
        volume = 0.5;

    return {
        storySoundVolume,
        soundVolume,
        soundEffectVolume,
        timelines,
        volume
    };
}

export const VolumeSlider = connect(mapStateToProps)(VolumeSliderContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/VolumeSlider.js
 **/